import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { useHubSnackBar } from "../hooks";

export const handleDownloadPdf = async ({ id, name = "downlaod" }) => {
  try {
    if (!id) return;

    const element = document.getElementById(id);
    if (!element) throw new Error(`No element with id ${id} found`);

    const canvas = await html2canvas(element, { scale: 2 });
    const imageData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("portrait", "pt", [612, 792]); // US Letter size in points (8.5x11 inches)

    const pdfWidth = 612; // 8.5 inches in points
    const pdfHeight = 792; // 11 inches in points

    const canvasWidth = canvas.width;
    const canvasHeight = canvas.height;
    const scaleFactor = Math.min(
      pdfWidth / canvasWidth,
      pdfHeight / canvasHeight
    );

    const scaledWidth = canvasWidth * scaleFactor;
    const scaledHeight = canvasHeight * scaleFactor;

    const xOffset = (pdfWidth - scaledWidth) / 2;
    const yOffset = (pdfHeight - scaledHeight) / 2;

    pdf.addImage(imageData, "PNG", xOffset, yOffset, scaledWidth, scaledHeight);
    pdf.save(`${name}.pdf`);
    return true;
  } catch (e) {
    console.log("Failed to download file", e, "\nfor element ", id);
    return false;
  }
};

export const useHandleMultiPageDownload = ({
  name,
  className = ".print-only",
  flip = false,
  snackbar,
  print,
}) => {
  const handleDownload = async () => {
    const elements = document.querySelectorAll(className);
    const ids = Array.from(elements)
      .map((el) => el.id)
      .filter(Boolean);

    await handleDownloadMultiPagePdf({ ids, name, flip, print }, snackbar);
  };
  return handleDownload;
};

export const handleDownloadMultiPagePdf = async (
  { ids = [], name = "download", flip = false, print },
  snackbar = {}
) => {
  const {
    addSnackbarSuccess = () => {},
    addSnackbarInfo = () => {},
    addSnackbarError = () => {},
  } = snackbar;

  try {
    if (!Array.isArray(ids) || ids.length === 0) return;

    addSnackbarInfo({
      message: print ? "Preparing Print" : "Starting Download",
    });

    const width = flip ? 792 : 612;
    const height = flip ? 612 : 792;

    const pdf = new jsPDF(flip ? "landscape" : "portrait", "pt", [
      width,
      height,
    ]); // US Letter

    for (let i = 0; i < ids.length; i++) {
      const id = ids[i];
      const element = document.getElementById(id);
      if (!element) throw new Error(`No element with id ${id} found`);

      const canvas = await html2canvas(element, { scale: 2 });
      const imageData = canvas.toDataURL("image/png");

      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      const scaleFactor = Math.min(width / canvasWidth, height / canvasHeight);

      const scaledWidth = canvasWidth * scaleFactor;
      const scaledHeight = canvasHeight * scaleFactor;
      const xOffset = (width - scaledWidth) / 2;
      const yOffset = (height - scaledHeight) / 2;

      if (i > 0) pdf.addPage(); // Add a new page except for the first
      pdf.addImage(
        imageData,
        "PNG",
        xOffset,
        yOffset,
        scaledWidth,
        scaledHeight
      );
    }

    if (print) window.open(pdf.output("datauristring"), "_blank");
    else pdf.save(`${name}.pdf`);

    addSnackbarSuccess({
      message: print ? "Print Successful" : "Download Successful",
    });
  } catch (e) {
    console.log("Failed to download file", e);
    addSnackbarError({ message: "Failed to Download File" });
  }
};
